// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-input,
.ant-select-selector,
.ant-select-arrow {
  padding: 0 1.5rem !important;
}
.ant-input-prefix {
  padding-left: 1.5rem;
}
.gyramais-input,
.gyramais-input > input {
  min-height: 3.5rem;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 1.25rem;
  font-size: 1rem;
}
.gyramais-input input,
.gyramais-input > input input {
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 300;
}
.gyramais-input::-webkit-input-placeholder,
.gyramais-input > input::-webkit-input-placeholder {
  font-size: 1rem;
}
.gyramais-input:hover,
.gyramais-input > input:hover {
  border-color: var(--primary-button-color);
}
.gyramais-input:focus,
.gyramais-input > input:focus {
  border-color: var(--primary-button-color);
  box-shadow: 0 0 4px var(--primary-button-color);
}
.gyramais-input.ant-select-single .ant-select-selector,
.gyramais-input > input.ant-select-single .ant-select-selector {
  height: 3.5rem !important;
}
.gyramais-input .ant-input-group,
.gyramais-input > input .ant-input-group {
  min-height: 3.5rem;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 1.25rem;
  font-size: 1rem;
}
.gyramais-input .ant-input-group .ant-input,
.gyramais-input > input .ant-input-group .ant-input {
  min-height: 3.5rem;
  width: 100%;
  border-top-right-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}
.gyramais-input .ant-input-group .ant-input-group-addon,
.gyramais-input > input .ant-input-group .ant-input-group-addon {
  min-height: 3.5rem;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
}
.gyramais-input .ant-select-selector,
.gyramais-input > input .ant-select-selector,
.gyramais-input .ant-select-selection-search-input,
.gyramais-input > input .ant-select-selection-search-input {
  height: 100% !important;
  border-radius: 1.25rem !important;
  width: 100%;
  padding: none;
}
.gyramais-input .ant-select-selection-placeholder,
.gyramais-input > input .ant-select-selection-placeholder,
.gyramais-input .ant-select-selection-item,
.gyramais-input > input .ant-select-selection-item {
  display: flex !important;
  align-items: center !important;
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.5rem;
}
.gyramais-input .ant-select-arrow,
.gyramais-input > input .ant-select-arrow {
  color: var(--primary-color);
}
.gyramais-input.ant-input-affix-wrapper,
.gyramais-input > input.ant-input-affix-wrapper {
  padding: 0 1rem 0 0;
}
.gyramais-input.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,
.gyramais-input > input.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
  border-color: var(--primary-button-color);
}
.gyramais-input.ant-input-affix-wrapper-focused,
.gyramais-input > input.ant-input-affix-wrapper-focused {
  border-color: var(--primary-button-color);
  box-shadow: 0 0 4px var(--primary-button-color);
}
.gyramais-input-skeleton {
  width: 100% !important;
  height: 3.5rem !important;
  border-radius: 0.25rem !important;
}
.gyramais-input.ant-select-multiple .ant-select-selection-item {
  height: 90% !important;
  border-radius: 0.25rem;
}
.gyramais-input.ant-select-multiple .ant-select-selection-overflow {
  padding: 0.75rem 0rem;
}
.custom-input-tooltip {
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  top: 24%;
  right: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/gyramais/Input/styles.less"],"names":[],"mappings":"AAAA;;;EACE,4BAAA;AAGF;AAAA;EACE,oBAAA;AAEF;AACA;;EAEE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AACF;AARA;;EAUI,eAAA;EACA,mBAAA;EACA,gBAAA;AAEJ;AAEE;;EACE,eAAA;AACJ;AAEE;;EACE,yCAAA;AACJ;AAEE;;EACE,yCAAA;EACA,+CAAA;AACJ;AAEE;;EAEI,yBAAA;AAAN;AA/BA;;EAoCI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AADJ;AAxCA;;EA4CM,kBAAA;EACA,WAAA;EAEA,gCAAA;EACA,mCAAA;AADN;AA/CA;;EAoDM,kBAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,+BAAA;EACA,kCAAA;AAHN;AAzDA;;;;EAkEI,uBAAA;EACA,iCAAA;EACA,WAAA;EACA,aAAA;AAHJ;AAlEA;;;;EA2EI,wBAAA;EACA,8BAAA;EAEA,eAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;AA5EA;;EAoFI,2BAAA;AAJJ;AAOE;;EACE,mBAAA;AAJJ;AAOE;;EACE,yCAAA;AAJJ;AAOE;;EACE,yCAAA;EACA,+CAAA;AAJJ;AAQA;EACE,sBAAA;EACA,yBAAA;EACA,iCAAA;AANF;AASA;EAEI,sBAAA;EACA,sBAAA;AARJ;AAKA;EAOI,qBAAA;AATJ;AAaA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAXF","sourcesContent":[".ant-input, .ant-select-selector, .ant-select-arrow {\n  padding: 0 1.5rem !important;\n}\n\n.ant-input-prefix {\n  padding-left: 1.5rem;\n}\n\n.gyramais-input,\n.gyramais-input > input {\n  min-height: 3.5rem;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  border-radius: @border-radius;\n  font-size: 1rem;\n\n  input {\n    font-size: 1rem;\n    line-height: 1.5rem;\n    font-weight: 300;\n\n  }\n\n  &::-webkit-input-placeholder {\n    font-size: 1rem;\n  }\n\n  &:hover {\n    border-color: var(--primary-button-color);\n  }\n\n  &:focus {\n    border-color: var(--primary-button-color);\n    box-shadow: 0 0 4px var(--primary-button-color);\n  }\n\n  &.ant-select-single {\n    .ant-select-selector {\n      height: 3.5rem !important;\n    }\n  }\n\n  .ant-input-group {\n    min-height: 3.5rem;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    border-radius: @border-radius;\n    font-size: 1rem;\n\n    .ant-input {\n      min-height: 3.5rem;\n      width: 100%;\n\n      border-top-right-radius: @border-radius;\n      border-bottom-right-radius: @border-radius;\n    }\n\n    .ant-input-group-addon {\n      min-height: 3.5rem;\n      width: auto;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      border-top-left-radius: @border-radius;\n      border-bottom-left-radius: @border-radius;\n    }\n  }\n\n  .ant-select-selector,\n  .ant-select-selection-search-input {\n    height: 100% !important;\n    border-radius: @border-radius !important;\n    width: 100%;\n    padding: none;\n  }\n\n  \n  .ant-select-selection-placeholder,\n  .ant-select-selection-item {\n    display: flex !important;\n    align-items: center !important;\n\n    font-size: 1rem;\n    font-weight: 300;\n    line-height: 1.5rem;\n  }\n\n  .ant-select-arrow {\n    color: var(--primary-color)\n  }\n\n  &.ant-input-affix-wrapper {\n    padding: 0 1rem 0 0;\n  }\n\n  &.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n    border-color: var(--primary-button-color);\n  }\n  \n  &.ant-input-affix-wrapper-focused {\n    border-color: var(--primary-button-color);\n    box-shadow: 0 0 4px var(--primary-button-color);\n  }\n}\n\n.gyramais-input-skeleton {\n  width: 100% !important;\n  height: 3.5rem !important;\n  border-radius: .25rem !important;\n}\n\n.gyramais-input.ant-select-multiple {\n  .ant-select-selection-item {\n    height: 90% !important;\n    border-radius: .25rem;\n  }\n\n  .ant-select-selection-overflow {\n    padding: .75rem 0rem;\n  }\n}\n\n.custom-input-tooltip {\n  position: absolute;\n  width: 1.5rem;\n  height: 1.5rem;\n  top: 24%;\n  right: 0.6rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
